import fields from "../fields";

export default function getField(component) {
  if (fields[component.component]) {
    const Comp = fields[component.component];
    return <Comp {...component} name={component.key} />
  } else {
    return null
  }
}